<script lang="ts">
  import {recap} from '@/store';
  import Image from './Layers/Image.svelte';
  import Video from './Layers/Video.svelte';
  import Subtitle from './Layers/Subtitle.svelte';

  let composition: any[];
  $: composition = $recap.composition || [];
</script>

<div class="grid w-full gap-1">
  {#each composition as element}
    {#if element.type === 'image-element'}
      <Image properties={element.properties} />
    {:else if element.type === 'subtitle-element'}
      <Subtitle properties={element.properties} />
    {:else if element.type === 'video-element'}
      <Video properties={element.properties} />
    {/if}
  {/each}
</div>
